import {
  Alert,
  Box,
  Button,
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useWebContent } from "./provider";
import { useEffect } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { createYupSchema } from "../../utilities/yupSchemaCreator";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useTheme } from "@emotion/react";
import fields from "./fields";
import styled from "styled-components";
import { ShowPrice } from "../../utilities/Enum";
import { useSite } from "../Sites/Provider";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
import ErrorsList from "../../ui/ErrorsList";

const yupSchema = fields.reduce(createYupSchema, {});
const formSchema = Yup.object().shape(yupSchema);

const ButtonWrapper = styled.div`
  margin-bottom: 50px;
  button {
    float: right;
    margin-left: 20px;
  }
`;

const PreviewImage = styled.div`
  border: 1px dashed rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
`;

const RemoveButton = styled.button`
  background-color: rgba(255, 0, 0, 0.7);
  cursor: pointer;
  border: none;
  width: 35px;
  height: 35px;
  border-radius: 100%;
  position: absolute;
  top: 5px;
  right: 5px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(255, 0, 0, 0.9);
    transform: scale(1.1);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: scale(0.95);
  }
`;

const FormWebContent = ({ handleSuccess, WebContentInfo }) => {
  let theme = useTheme();
  let navigate = useNavigate();
  const { id } = useParams();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
    defaultValues: {
      photo: WebContentInfo?.photo || "",
      times: WebContentInfo?.times || [],
    },
  });
  const [previewUrl, setPreviewUrl] = useState(
    WebContentInfo?.photoUrl || null
  );
  const [error, setError] = useState();

  const { setWebContent, uploadPhoto } = useWebContent();
  const {
    state: { selected: site },
  } = useSite();

  const handleUploadPhoto = async (file) => {
    if (!file) return;

    try {
      const result = await uploadPhoto(file, id);
      setValue("photo", result?.fileName || result?.url);
      const objectUrl = URL.createObjectURL(file);
      setPreviewUrl(objectUrl);
      if (previewUrl && previewUrl.startsWith("blob:")) {
        URL.revokeObjectURL(previewUrl);
      }
    } catch (error) {
      console.error("Upload failed:", error);
      setError({
        title: error.errors.message ? error.errors.message : "some thing wrong",
      });
      setPreviewUrl(WebContentInfo?.photo || null);
    }
  };

  const handleRemove = () => {
    setPreviewUrl("");
    setValue("photo", "");
  };
  const onSubmit = async (values) => {
    try {
      await setWebContent(id, values);
      handleSuccess();
    } catch (error) {
      console.log(error, "error");
      setError({
        title: error.errors.message ? error.errors.message : "some thing wrong",
      });
    }
  };
  const timesField = fields.find((f) => f.multiSelect);
  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      {error && (
        <Alert severity="error">
          <ErrorsList error={error} />
        </Alert>
      )}
      <Card
        sx={{
          p: theme.dimensions.padding,
          mt: theme.dimensions.mt,
          mb: theme.dimensions.mb,
        }}
      >
        <Typography variant="Poster" mb={3} component="h4" gutterBottom>
          Web Content Details
        </Typography>

        <div style={{ display: "flex" }}>
          <div>
            {fields?.filter((f) => !f.multiSelect)?.map((f, index) =>
              !f.switch ? (
                <React.Fragment>
                {f.select ? (
                    <>
                      <FormControl
                        sx={{
                          width: theme.dimensions.width,
                          mt: theme.dimensions.mt,
                          mb: theme.dimensions.mb,
                        }}
                        size="small"
                      >
                        <InputLabel
                          id="demo-simple-select-label"
                          htmlFor="demo-simple-select"
                        >
                          {f.label}
                          {" *"}
                        </InputLabel>
                        <Select
                          label={f.label}
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          size="small"
                          error={!!errors[f.name]?.message}
                          inputProps={{
                            defaultValue:
                              site?.country === "Saudi Arabia" ||
                              site?.address === "Dubai"
                                ? 1
                                : WebContentInfo?.showPrice,
                            ...register(f?.name),
                          }}
                        >
                          {ShowPrice?.map((c, i) => (
                            <MenuItem key={i} value={c.id}>
                              {c.desription}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText
                          htmlFor="demo-simple-select"
                          sx={{ color: "#d32f2f" }}
                        >
                          {errors[f.name]?.message}
                        </FormHelperText>
                      </FormControl>
                    </>
                  ) : (
                    <div style={{ marginBottom: "20px" }}>
                      <TextField
                        key={index}
                        sx={{
                          width: theme.dimensions.width * 2,
                          mt: theme.dimensions.mt,
                          mb: theme.dimensions.mb,
                        }}
                        type={f.type}
                        error={!!errors[f.name]}
                        size="small"
                        inputProps={{
                          ...register(f?.name),
                          defaultValue: WebContentInfo?.[f.name],
                        }}
                        multiline={f.name != "caption" ? true : false}
                        rows={3}
                        maxRows={10}
                        required={f.required}
                        label={f.label}
                      />
                    </div>
                  )}
                </React.Fragment>
              ) : (
                <Box>
                  <FormGroup>
                    <FormLabel
                      component="legend"
                      sx={{
                        mt: theme.dimensions.mt,
                      }}
                    >
                      {f.label}
                    </FormLabel>
                    <FormControlLabel
                      sx={{
                        mt: theme.dimensions.mt,
                      }}
                      control={
                        <Switch
                          color="success"
                          defaultChecked={
                            WebContentInfo
                              ? WebContentInfo?.showOfficialPrice
                              : true
                          }
                        />
                      }
                      {...register(f?.name)}
                      label="Active"
                    />
                  </FormGroup>
                </Box>
              )
            )}
          </div>
          <div style={{ marginInline: "10px", marginTop: "-20px" }}>
            <Typography variant="body2" component="h6" gutterBottom>
              Site Photo
            </Typography>
            <PreviewImage>
              {previewUrl && (
                <RemoveButton onClick={handleRemove}>
                  <DeleteTwoToneIcon fontSize="small" />
                </RemoveButton>
              )}
              {previewUrl && (
                <div>
                  <img
                    src={previewUrl}
                    alt="Preview"
                    style={{ maxWidth: "200px", marginBottom: "16px" }}
                  />
                </div>
              )}
              <TextField
                type="file"
                fullWidth
                helperText={
                  WebContentInfo?.photo
                    ? `Current photo: ${WebContentInfo.photo.split("/").pop()}`
                    : "User Photo : Accepts .svg, .gif, .jpg, and .png"
                }
                onChange={(e) => {
                  if (e.target.files && e.target.files[0]) {
                    handleUploadPhoto(e.target.files[0]);
                  }
                }}
                sx={{
                  width: theme.dimensions.width,
                }}
              />
            </PreviewImage>
          </div>
        </div>
        {timesField && (
          <FormControl
            sx={{
              width: theme.dimensions.width,
              mt: theme.dimensions.mt,
              mb: theme.dimensions.mb,
            }}
            size="small"
          >
            <InputLabel id="label-multi-times" htmlFor="select-multi-times">
              {timesField.label}
            </InputLabel>
            <Select
              labelId="label-multi-times"
              id="select-multi-times"
              label={timesField.label}
              multiple
              size="small"
              value={watch("times") || []}
              onChange={(e) =>
                setValue(
                  "times",
                  (e.target.value || []).map((v) => Number(v)),
                )
              }
              error={!!errors.times?.message}
              renderValue={(selected) =>
                (selected || [])
                  .map((val) => {
                    const opt = timesField.options?.find((o) => o.id === val);
                    return opt ? opt.label : val;
                  })
                  .join(", ")
              }
            >
              {(timesField.options || []).map((opt) => (
                <MenuItem key={opt.id} value={opt.id}>
                  <Checkbox
                    checked={(watch("times") || []).indexOf(opt.id) > -1}
                  />
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText
              htmlFor="select-multi-times"
              sx={{ color: "#d32f2f" }}
            >
              {errors.times?.message}
            </FormHelperText>
          </FormControl>
        )}
        <ButtonWrapper>
          <Button
            variant="contained"
            type="submit"
            sx={{
              backgroundColor: theme.color.blackBackground,
              ml: theme.dimensions.ml,
              "&:hover": { background: `${theme.color.black}` },
            }}
          >
            Save Web Content
          </Button>
          <Button
            variant="contained"
            onClick={() => navigate(-1)}
            sx={{
              backgroundColor: theme.color.grayBackground,
              color: theme.color.dark,
              "&:hover": { background: `${theme.color.gray50}` },
            }}
          >
            Discard
          </Button>
        </ButtonWrapper>
      </Card>
    </form>
  );
};

export default FormWebContent;
